import { Button, Heading, Icon, IconType, PageHeader } from '@lmc/ui-kit'
import { Text } from '@lmc/ui-kit/src/general'
import { Row } from 'antd'
import { useRouter } from 'hooks/useRouter'
import { NAMESPACE } from 'locale'
import { selfServeConstants } from 'locale/selfServe'
import type { FC } from 'react'
import { useTranslation } from 'react-i18next'
import { Link } from 'react-router-dom'
import styled from 'styled-components'
import { CardFormat } from './components'

const ALL_ARTICLES = 'https://support.logmycare.co.uk/en/'

const GETTING_STARTED =
  'https://support.logmycare.co.uk/en/articles/4915799-get-started-with-log-my-care'

const WEBINARS = 'https://support.logmycare.co.uk/en/?q=webinars'

const FEEDBACK =
  'https://portal.productboard.com/ambpva5y3bxf5myjgnmwwnpg/tabs/1-under-consideration?hideLogo=1&token=eyJhbGciOiJIUzI1NiIsInR5cCI6IkpXVCJ9.eyJlbWFpbCI6ImphY2tAbG9nbXljYXJlLmNvLnVrIiwiaWQiOiI2MTZlZWI0NTE2MDNjZTZkZThjOWI5YjEiLCJuYW1lIjoiSmFjayBUaG9tYXMiLCJjb21wYW55X25hbWUiOiJDdWJpdHQgSG91c2UiLCJpYXQiOjE2ODkwMDcwMTR9.5zZ5Qx6SCEVIc2DvdCXXmLf2lwsr77hpmlgT1A1lwI'

const EMAR =
  'https://support.logmycare.co.uk/en/articles/5170305-carer-app-emar-walkthrough'

const BILLING = '/settings/billing'

const FAQ = 'https://support.logmycare.co.uk/en/collections/794841-faqs'

const GOING =
  'https://logmycare.sharepoint.com/:b:/g/EfRC9HlKk3lLvGRMgfDsb-gBoV8XZuNz-xD92tolBxE9ug?e=dL4ODV'

const IMPACT =
  'https://logmycare.sharepoint.com/:b:/g/EfRC9HlKk3lLvGRMgfDsb-gBoV8XZuNz-xD92tolBxE9ug?e=dL4ODV'

const FACEBOOK = 'https://www.facebook.com/LogmyCare'

const YOUTUBE = 'https://www.youtube.com/channel/UCO9oelNy1WbalKVswSytToQ'

const TWITTER = 'https://twitter.com/LogmyCare'

const LINKED = 'https://www.linkedin.com/company/27206947'

const LINK_GETTING =
  'https://support.logmycare.co.uk/en/collections/794905-getting-started'

const LINK_CO =
  'https://support.logmycare.co.uk/en/collections/794793-the-care-office'

const LINK_CA =
  'https://support.logmycare.co.uk/en/collections/794813-the-carer-app'

const LINK_PRO =
  'https://support.logmycare.co.uk/en/collections/1681220-the-pro-plan'

const LINK_OUTSTANDING =
  'https://support.logmycare.co.uk/en/collections/2248853-the-outstanding-plan'

const LINK_MEDICATION =
  'https://support.logmycare.co.uk/en/collections/2749236-medication-administration-emar'

const LINK_FAMILY =
  'https://support.logmycare.co.uk/en/collections/2455677-family-portal'

const LINK_KEEP =
  'https://support.logmycare.co.uk/en/collections/3541178-keep-your-service-s-data-secure'

const LINK_CORONA =
  'https://support.logmycare.co.uk/en/collections/2215090-coronavirus-resources'

const LINK_SUPPORT =
  'https://support.logmycare.co.uk/en/collections/794832-support'

export const HelpCentreScreen: FC = () => {
  const router = useRouter()

  const { t } = useTranslation(NAMESPACE.SELF_SERVE)

  return (
    <Wrapper>
      <PageHeader
        onBackTitle={t(selfServeConstants.GO_TO_HOMEDASH)}
        onBack={() => router.navigate('/')}
        childrenTitle={
          <>
            <Icon
              customIcon={IconType.NewLogo}
              style={{ width: 41, height: 41 }}
            />
            <Icon
              customIcon={IconType.HelpCentreText}
              style={{ width: 200, height: 41 }}
            />
          </>
        }
      >
        <Link to={ALL_ARTICLES} target="_blank" rel="noopener noreferrer">
          <Button variant="primary">
            {t(selfServeConstants.VIEW_ALL_ARTICLES)}
          </Button>
        </Link>
      </PageHeader>
      <StyledHeading level={3}>{t(selfServeConstants.NEED_HELP)}</StyledHeading>
      <Row gutter={24}>
        <CardFormat>
          <>
            <IconWrapper>
              <Icon
                customIcon={IconType.GettingStartedIcon}
                style={{ width: 33, height: 47 }}
              />
            </IconWrapper>
            <Link
              to={GETTING_STARTED}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StyledCardHeading level={3}>
                {t(selfServeConstants.GETTING_STARTED)}
              </StyledCardHeading>
            </Link>
            <StyledCardDesc>{t(selfServeConstants.DIVE_IN)}</StyledCardDesc>
          </>
        </CardFormat>
        <CardFormat>
          <>
            <IconWrapper>
              <Icon
                customIcon={IconType.WebinarIcon}
                style={{ width: 47, height: 39 }}
              />
            </IconWrapper>
            <Link to={WEBINARS} target="_blank" rel="noopener noreferrer">
              <StyledCardHeading level={3}>
                {t(selfServeConstants.VIEW_OUR)}
              </StyledCardHeading>
            </Link>
            <StyledCardDesc>
              {t(selfServeConstants.GET_FIRST_HAND)}
            </StyledCardDesc>
          </>
        </CardFormat>
        <CardFormat>
          <>
            <IconWrapper>
              <Icon
                customIcon={IconType.FeedbackIcon}
                style={{ width: 47, height: 43 }}
              />
            </IconWrapper>
            <Link to={FEEDBACK} target="_blank" rel="noopener noreferrer">
              <StyledCardHeading level={3}>
                {t(selfServeConstants.SHARE_YOUR)}
              </StyledCardHeading>
            </Link>
            <StyledCardDesc>{t(selfServeConstants.TELL_US)}</StyledCardDesc>
          </>
        </CardFormat>
        <CardFormat>
          <>
            <IconWrapper>
              <Icon
                customIcon={IconType.SideMedication}
                style={{ width: 47, height: 47 }}
              />
            </IconWrapper>
            <Link to={EMAR} target="_blank" rel="noopener noreferrer">
              <StyledCardHeading level={3}>
                {t(selfServeConstants.EMAR_WALK)}
              </StyledCardHeading>
            </Link>
            <StyledCardDesc>
              {t(selfServeConstants.EMAR_WALK_DESC)}
            </StyledCardDesc>
          </>
        </CardFormat>
      </Row>
      <Row gutter={24}>
        <CardFormat size="lg">
          <>
            <IconWrapper>
              <Icon
                customIcon={IconType.BillingHelpIcon}
                style={{ width: 49, height: 33 }}
              />
            </IconWrapper>
            <Link to={BILLING} style={{ textDecoration: 'none' }}>
              <StyledCardHeading level={3}>
                {t(selfServeConstants.BILLING)}
              </StyledCardHeading>
            </Link>
            <StyledCardDesc>{t(selfServeConstants.REVIEW)}</StyledCardDesc>
          </>
        </CardFormat>
        <CardFormat size="lg">
          <>
            <IconWrapper>
              <Icon
                customIcon={IconType.FaqIcon}
                style={{ width: 49, height: 49 }}
              />
            </IconWrapper>
            <Link to={FAQ} target="_blank" rel="noopener noreferrer">
              <StyledCardHeading level={3}>
                {t(selfServeConstants.FAQS)}
              </StyledCardHeading>
            </Link>
            <StyledCardDesc>{t(selfServeConstants.BROWSE)}</StyledCardDesc>
          </>
        </CardFormat>
      </Row>
      <StyledHeading level={3}>{t(selfServeConstants.IS_IT)}</StyledHeading>
      <LinkWrapper>
        <LinkHeadingkRow>
          <StyledSupportHeading level={4}>
            {t(selfServeConstants.SUPPORT_INDEX)}
          </StyledSupportHeading>
          <Link to={ALL_ARTICLES} target="_blank" rel="noopener noreferrer">
            <StyledViewArticles>
              {t(selfServeConstants.LINK_VIEW_ALL)}
            </StyledViewArticles>
          </Link>
        </LinkHeadingkRow>
        <LinkInnerWrapper>
          <LinkInnerColumn>
            <Link to={LINK_GETTING} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_GETTING)}</StyledLink>
            </Link>
            <Link to={LINK_CO} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_CO)}</StyledLink>
            </Link>
            <Link to={LINK_CA} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_CA)}</StyledLink>
            </Link>
            <Link to={LINK_PRO} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_PRO)}</StyledLink>
            </Link>
            <Link
              to={LINK_OUTSTANDING}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StyledLink>{t(selfServeConstants.LINK_OUTSTANDING)}</StyledLink>
            </Link>
          </LinkInnerColumn>
          <LinkInnerColumn>
            <Link
              to={LINK_MEDICATION}
              target="_blank"
              rel="noopener noreferrer"
            >
              <StyledLink>{t(selfServeConstants.LINK_MEDICATION)}</StyledLink>
            </Link>
            <Link to={LINK_FAMILY} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_FAMILY)}</StyledLink>
            </Link>
            <Link to={LINK_KEEP} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_KEEP)}</StyledLink>
            </Link>
            <Link to={LINK_CORONA} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_CORONA)}</StyledLink>
            </Link>
            <Link to={LINK_SUPPORT} target="_blank" rel="noopener noreferrer">
              <StyledLink>{t(selfServeConstants.LINK_SUPPORT)}</StyledLink>
            </Link>
          </LinkInnerColumn>
        </LinkInnerWrapper>
      </LinkWrapper>
      <LinkWrapper>
        <LinkInnerWrapper>
          <LeftColumn>
            <StyledDownload>
              {t(selfServeConstants.DOWNLOAD_MORE)}
            </StyledDownload>
            <Link to={GOING} target="_blank" rel="noopener noreferrer">
              <StyledDownloadPdf>
                {t(selfServeConstants.GOING)}
              </StyledDownloadPdf>
            </Link>
            <Link to={IMPACT} target="_blank" rel="noopener noreferrer">
              <StyledDownloadPdf>
                {t(selfServeConstants.IMPACT)}
              </StyledDownloadPdf>
            </Link>
          </LeftColumn>
          <LeftColumn>
            <StyledHeadingConnect level={3}>
              {t(selfServeConstants.CONNECT_WITH)}
            </StyledHeadingConnect>
            <SocialWrapper>
              <Link to={FACEBOOK} target="_blank" rel="noopener noreferrer">
                <IconWrapper>
                  <Icon
                    customIcon={IconType.FacebookIcon}
                    style={{ width: 40, height: 40 }}
                  />
                </IconWrapper>
              </Link>
              <Link to={YOUTUBE} target="_blank" rel="noopener noreferrer">
                <IconWrapper>
                  <Icon
                    customIcon={IconType.YoutubeIcon}
                    style={{ width: 40, height: 40, marginLeft: 15 }}
                  />
                </IconWrapper>
              </Link>
              <Link to={TWITTER} target="_blank" rel="noopener noreferrer">
                <IconWrapper>
                  <Icon
                    customIcon={IconType.SocialTwitterIcon}
                    style={{ width: 40, height: 40, marginLeft: 15 }}
                  />
                </IconWrapper>
              </Link>
              <Link to={LINKED} target="_blank" rel="noopener noreferrer">
                <IconWrapper>
                  <Icon
                    customIcon={IconType.SocialLinkedIcon}
                    style={{ width: 40, height: 40, marginLeft: 15 }}
                  />
                </IconWrapper>
              </Link>
            </SocialWrapper>
          </LeftColumn>
        </LinkInnerWrapper>
      </LinkWrapper>
    </Wrapper>
  )
}

const Wrapper = styled.div`
  max-width: 1390px;
  margin-left: auto;
  margin-right: auto;
  padding: 24px;
  display: flex;
  flex-direction: column;
`

const StyledHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  margin-top: 40px;
  margin-bottom: 24px;
`

const StyledCardHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.status.primary};
  text-decoration: none !important;
  font-size: 20px;
`

const StyledCardDesc = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color3};
`

const LinkWrapper = styled.div`
  background-color: ${({ theme }) => theme.color.neutral.color11};
  border-radius: 20px;
  padding: 16px 24px;
  margin-bottom: 24px;
`

const LinkHeadingkRow = styled.div`
  background-color: ${({ theme }) => theme.color.neutral.color11};
  border-radius: 20px;
  display: flex;
  justify-content: space-between;
`

const StyledSupportHeading = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  margin-bottom: 16px;
`

const StyledViewArticles = styled(Text)`
  color: ${({ theme }) => theme.color.status.primary};
  text-decoration: underline;
`

const LinkInnerWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    flex-direction: column;
  }
`

const LinkInnerColumn = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
`

const StyledLink = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
  font-size: 24px;
  font-weight: 400;
  line-height: 35px;
  text-decoration: underline;
  text-align: left;
`

const StyledDownload = styled(Text)`
  color: ${({ theme }) => theme.color.neutral.color4};
`

const StyledDownloadPdf = styled(Text)`
  color: ${({ theme }) => theme.color.status.primary};
  line-height: 30px;
`

const StyledHeadingConnect = styled(Heading)`
  color: ${({ theme }) => theme.color.neutral.color4};
  font-size: 18px;
  text-align: right;
  ${({ theme }) => theme.mediaQueries.mobileDown} {
    margin-top: 10px;
  }
`

const SocialWrapper = styled.div`
  display: flex;
  margin-left: auto;
`

const IconWrapper = styled.div`
  height: 50px;
`

const LeftColumn = styled.div`
  display: flex;
  flex-direction: column;
`
